var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "m7.667 17.571l-.381-.312c.184-.249.977-.75 1.35-.973c.634.085 1.714.265.964.33c-.754.068-1.603.664-1.933.955M16.68 18l.463-.386c-.197-.407-1.179-1.315-1.5-1.543c-.553.086-1.513.51-.857.579c.651.069 1.607 1.05 1.894 1.35m-7.234-7.547a.274.274 0 0 1 .342-.15l1.179.42a.252.252 0 0 1 .087.43a.27.27 0 0 1-.16.067a2.7 2.7 0 0 0-.557.124a2.7 2.7 0 0 0-.501.193a.28.28 0 0 1-.369-.094a.253.253 0 0 1 .094-.352a3 3 0 0 1 .416-.171l-.373-.137a.257.257 0 0 1-.158-.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    fillRule: "evenodd",
    d: "M15.428 6.746a2.75 2.75 0 0 0-.278-1.175c.63.159 1.564.836 1.564 1.955c0 1.123-.96 1.8-1.414 1.903c-.45.107-.45.625-.45.81c0 .18.3 1.564.578 1.8a1.63 1.63 0 0 1 .858 1.641v1.38c0 1.44-2.469 2.083-4.286 2.083s-3.052-.467-3.707-.909c-.523-.356-.57-.93-.579-1.174v-1.513c0-1.23.926-1.53 1.436-1.547h2.194c.587 0 .656-.386.656-.549V9.874c0-1.123.883-1.564 1.916-1.697c1.032-.128 1.512-.78 1.512-1.431m-6.085 6.111h5.305c.583 0 .798.579.78.832v1.371c0 .883-2.301 1.183-3.454 1.226c-1.131-.043-3.403-.343-3.403-1.226v-1.372c-.017-.252.193-.83.772-.83m4.157-1.286c.356 0 .643-.385.643-.857c0-.471-.287-.857-.643-.857s-.643.386-.643.857c0 .472.287.857.643.857",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M10.286 13.286h-.858a.43.43 0 0 0-.428.428v.857c0 .237.192.429.428.429h.858a.43.43 0 0 0 .428-.429v-.857a.43.43 0 0 0-.428-.428m4.285 0h-.857a.43.43 0 0 0-.428.428v.857c0 .237.191.429.428.429h.857a.43.43 0 0 0 .429-.429v-.857a.43.43 0 0 0-.429-.428m-6-3.257a1.79 1.79 0 0 0-1.813.171A1.95 1.95 0 0 0 6 11.803c.321.167 1.131.403 1.813-.133a2.02 2.02 0 0 0 .758-1.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D45C",
    d: "M7.273 17.597a.65.65 0 0 0-.647.171a.73.73 0 0 0-.189.63c.129.043.433.078.651-.158a.74.74 0 0 0 .185-.643m.013-.711a.81.81 0 0 0-.802-.112a.84.84 0 0 0-.484.6c.12.107.45.292.797.137a.87.87 0 0 0 .489-.625M7.94 18c-.158.03-.51.189-.617.544a.78.78 0 0 0 .15.742c.163-.03.527-.168.634-.532A.8.8 0 0 0 7.941 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D45C",
    d: "M8.563 17.571c-.15.073-.437.317-.42.669c.017.351.283.54.42.617c.15-.073.458-.3.437-.66c-.026-.356-.292-.544-.437-.626m-.849-1.264c-.068-.15-.3-.45-.656-.45c-.351 0-.548.257-.63.386c.069.158.288.48.643.471c.356-.008.557-.261.643-.407"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M15.428 10.029c.322-.168 1.132-.348 1.813.171A1.95 1.95 0 0 1 18 11.803c-.322.167-1.132.403-1.813-.133a2.01 2.01 0 0 1-.759-1.646z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D45C",
    d: "M11.001 6.176L12 5.143l.998 1.033l1.145-.605q-.126.76-.287 1.513c-.266.523-1.342.639-1.856.63c-.51.009-1.59-.107-1.856-.63a33 33 0 0 1-.287-1.513z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F3FA",
    d: "M7.286 7.474a2.04 2.04 0 0 1 1.32-1.903c-.069.129-.215.532-.215 1.106a1.27 1.27 0 0 0 .913 1.234c.407.129.553.206.553.412c0 .643-.647 1.106-.84 1.106s-1.731-.515-1.731-1.955"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbx);
export default __webpack_public_path__ + "static/media/cbx.c595edb349d7f5a3a681271d6c88d3c6.svg";
export { ForwardRef as ReactComponent };